module.exports = __webpack_public_path__ + "static/media/chevron-right-icon.c735e00a.svg";